import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../components/notifications/useNotification';
import useDocumentMeta from '../../utils/useDocumentMeta';
import './NotFound.css'

const NotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { showError } = useNotification();

    useDocumentMeta('seo-notfound-title', 'seo-notfound-desc');

    const handleNavigation = (page) => {
        switch (page) {
            case "/":
                navigate("/");
                break;
            default:
                showError(t('unknown-error'));
        }
        }
    return (
        <div id='not-found' className='not-found'>
            <img id='not-found-logo' src="/images/logo.svg" alt='logo' onClick={() => handleNavigation("/")}></img>
            <h1>{t("404-error")}</h1>
            <h2>{t("page-not-exist")}</h2>
            <h2 id='not-found-go-back-home' onClick={() => handleNavigation("/")}><u>{t("go-back-home")}</u></h2>
        </div>
    );
};

export default NotFound;
